/**
 * @deprecated: Support for old role model and old UI, do not export.
 */
var UserRole;
(function (UserRole) {
    UserRole["Manager"] = "manager";
    UserRole["Admin"] = "admin";
    UserRole["SuperAdmin"] = "super-admin";
})(UserRole || (UserRole = {}));
export function isGlobalAdmin(business, user) {
    if (user && user.isGlobalAdmin) {
        return user.isGlobalAdmin;
    }
    if (user && !user.role) {
        // Probably deprecated, leaving for safety.
        return business.globalAdminIds.includes(user.uuid);
    }
    return false;
}
export function isManagerOfTeam(team, user) {
    /**
     * @todo: We will be attaching individual user:team mappings to each user object in future, future UI work will consume this.
     */
    if (team && user.role === UserRole.Manager) {
        return true;
    }
    return false;
}
export function isLeaderOfTeam(team, user) {
    /**
     * @todo: We will be attaching individual user:team mappings to each user object in future, future UI work will consume this.
     */
    if (team && user.role === UserRole.Manager) {
        return true;
    }
    return false;
}
